import { useCallback } from 'react';
import { useWeb3React } from '@web3-react/core';
import config from '../config';
import { Contract } from '@ethersproject/contracts';
import { ContractNames } from '../constants';

export const useGetContract = () => {
  const { account, provider } = useWeb3React();

  const types = {
    [ContractNames?.MATRIX_X2X4]: [config.contractMatrixX2X4, config.contractMatrixX2X4Abi],
    [ContractNames?.ROUTER]: [config.contractRouter, config.contractRouterAbi],
    [ContractNames?.NFT_PASS]: [config.contractNftPass, config.contractNftPassAbi],
    [ContractNames?.NFT_PROMO]: [config.contractNftPromo, config.contractNftPromoAbi],
    [ContractNames?.TIERS_SALE]: [config.contractTiersSale, config.contractTiersSaleAbi],
    [ContractNames?.PANCAKE]: [config.contractPancake, config.contractPancakeAbi],
    [ContractNames?.POLLY_TOKEN]: [config.contractPollyToken, config.contractPollyTokenAbi],
    [ContractNames?.ST_POLLY_TOKEN]: [config.contractStPollyToken, config.contractStPollyTokenAbi],
    [ContractNames?.STAKING]: [config.contractStaking, config.contractStakingAbi],
    [ContractNames?.ENERGY_NFT]: [config.contractEnergyNft, config.contractEnergyNftAbi],
    [ContractNames?.ENERGY_POOL]: [config.contractEnergyPool, config.contractEnergyPoolAbi],
    [ContractNames?.INCOME]: [config.contractIncome, config.contractIncomeAbi],
    [ContractNames?.INCOME_ROUTER]: [config.contractIncomeRouter, config.contractIncomeRouterAbi],
  };

  const getContract = useCallback((type, otherProvider) => {
    return new Promise(function (resolve, rejected) {
      const currentProvider = otherProvider ? otherProvider : provider;

      if (types[type] && currentProvider) {
        const contract = new Contract(
          ...types[type],
          otherProvider ? otherProvider : provider?.getSigner(account).connectUnchecked() || provider,
        );

        resolve(contract);
      } else {
        rejected('error init contract: ' + type);
      }
    });
  }, [account, provider]);

  return {
    getContract,
  };
};
